import React from 'react';
import { Routes as RouterRoutes, Route } from 'react-router-dom';
import Page from '../Page';
import Signin from '../../pages/Signin';
import Signup from '../../pages/Signup';
import MainWorkspace from '../../pages/MainWorkspace';
import NotFound from '../../pages/NotFound';
import ForgotPassword from '../../pages/ForgotPassword';
import ResetPassword from '../../pages/ResetPassword';
import ExpiredAccount from '../../pages/ExpiredAccount';
import * as guards from '../../util/guards';
import Payment from '../../pages/Payment';
import Account from '../../pages/Account';

const Routes = () => {
    return (
        <RouterRoutes>
            <Route path="/signin" element={<Page guard={guards.unauthenticated} component={Signin} />} />
            <Route path="/signup" element={<Page guard={guards.unauthenticated} component={Signup} />} />
            <Route path="/signup/verify/:verificationToken" element={<Page guard={guards.unauthenticated} component={Signup} />} />
            <Route path="/signup/:token" element={<Page guard={guards.unauthenticated} component={Signup} />} />
            <Route path="/subscribe" element={<Page guard={guards.profileSet} component={Payment} />} />
            <Route path="/" element={<Page guard={guards.activeSubscription} component={MainWorkspace} />} />
            <Route path="/case/:id" element={<Page guard={guards.activeSubscription} component={MainWorkspace} />} />
            <Route path="/case/:id/data" element={<Page guard={guards.activeSubscription} component={MainWorkspace} />} />
            <Route path="/expired" element={<Page component={ExpiredAccount} />} />
            <Route path="/forgotpassword" element={<Page component={ForgotPassword} />} />
            <Route path="/resetpassword/:token" element={<Page component={ResetPassword} />} />
            <Route path="/account" element={<Page guard={guards.profileSet} component={Account} />} />
            <Route path="*" element={<Page component={NotFound} />} />
        </RouterRoutes>
    );
};

export default Routes;
